<!-- 演示环境的鼠标指引：智能体按下时在落点画的小箭头 + 涟漪。整层不接收鼠标事件。 -->
<div
  class="demo-cursor"
  [class.is-visible]="visible()"
  [class.is-pressed]="pressed()"
  [style.transform]="cursorTransform()"
  aria-hidden="true"
>
  <svg class="demo-cursor-arrow" viewBox="0 0 24 24" width="22" height="22">
    <path d="M4 2 L4 20 L9 15.4 L11.5 21.3 L14.4 20.2 L11.9 14.3 L18.2 13.6 Z" />
  </svg>
</div>

@for (ripple of ripples(); track ripple.id) {
  <span
    class="demo-cursor-ripple"
    [style.left.px]="ripple.x"
    [style.top.px]="ripple.y"
    aria-hidden="true"
  ></span>
}
